import { render } from "./OrderLine.vue?vue&type=template&id=05b45a84&scoped=true&ts=true"
import script from "./OrderLine.vue?vue&type=script&lang=ts"
export * from "./OrderLine.vue?vue&type=script&lang=ts"

import "./OrderLine.vue?vue&type=style&index=0&id=05b45a84&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05b45a84"]])

export default __exports__